import React, { useState } from "react";
import "./MemoryPage.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postSettings } from "../actions/appAction";
import surasData from "./suraData";


// // const surasData = [
// //   { number: 1, name: "الفاتحة", pages: 1 },
// //   { number: 2, name: "البقرة", pages: 48 },
// //   { number: 3, name: "آل عمران", pages: 29 },
// //   { number: 4, name: "النساء", pages: 24 },
// //   { number: 5, name: "المائدة", pages: 23 },
// //   { number: 6, name: "الأنعام", pages: 26 },
// //   { number: 7, name: "الأعراف", pages: 24 },
// //   { number: 8, name: "الأنفال", pages: 10 },
// //   { number: 9, name: "التوبة", pages: 20 },
// //   { number: 10, name: "يونس", pages: 11 },
// //   { number: 11, name: "هود", pages: 12 },
// //   { number: 12, name: "يوسف", pages: 12 },
// //   { number: 13, name: "الرعد", pages: 6 },
// //   { number: 14, name: "إبراهيم", pages: 7 },
// //   { number: 15, name: "الحجر", pages: 6 },
// //   { number: 16, name: "النحل", pages: 13 },
// //   { number: 17, name: "الإسراء", pages: 12 },
// //   { number: 18, name: "الكهف", pages: 12 },
// //   { number: 19, name: "مريم", pages: 10 },
// //   { number: 20, name: "طه", pages: 12 },
// //   { number: 21, name: "الأنبياء", pages: 11 },
// //   { number: 22, name: "الحج", pages: 10 },
// //   { number: 23, name: "المؤمنون", pages: 10 },
// //   { number: 24, name: "النور", pages: 12 },
// //   { number: 25, name: "الفرقان", pages: 6 },
// //   { number: 26, name: "الشعراء", pages: 9 },
// //   { number: 27, name: "النمل", pages: 10 },
// //   { number: 28, name: "القصص", pages: 11 },
// //   { number: 29, name: "العنكبوت", pages: 7 },
// //   { number: 30, name: "الروم", pages: 6 },
// //   { number: 31, name: "لقمان", pages: 4 },
// //   { number: 32, name: "السجدة", pages: 3 },
// //   { number: 33, name: "الأحزاب", pages: 12 },
// //   { number: 34, name: "سبأ", pages: 9 },
// //   { number: 35, name: "فاطر", pages: 9 },
// //   { number: 36, name: "يس", pages: 8 },
// //   { number: 37, name: "الصافات", pages: 10 },
// //   { number: 38, name: "ص", pages: 6 },
// //   { number: 39, name: "الزمر", pages: 11 },
// //   { number: 40, name: "غافر", pages: 11 },
// //   { number: 41, name: "فصلت", pages: 6 },
// //   { number: 42, name: "الشورى", pages: 8 },
// //   { number: 43, name: "الزخرف", pages: 7 },
// //   { number: 44, name: "الدخان", pages: 3 },
// //   { number: 45, name: "الجاثية", pages: 4 },
// //   { number: 46, name: "الأحقاف", pages: 5 },
// //   { number: 47, name: "محمد", pages: 6 },
// //   { number: 48, name: "الفتح", pages: 5 },
// //   { number: 49, name: "الحجرات", pages: 3 },
// //   { number: 50, name: "ق", pages: 3 },
// //   { number: 51, name: "الذاريات", pages: 3 },
// //   { number: 52, name: "الطور", pages: 4 },
// //   { number: 53, name: "النجم", pages: 3 },
// //   { number: 54, name: "القمر", pages: 3 },
// //   { number: 55, name: "الرحمن", pages: 3 },
// //   { number: 56, name: "الواقعة", pages: 4 },
// //   { number: 57, name: "الحديد", pages: 5 },
// //   { number: 58, name: "المجادلة", pages: 3 },
// //   { number: 59, name: "الحشر", pages: 4 },
// //   { number: 60, name: "الممتحنة", pages: 3 },
// //   { number: 61, name: "الصف", pages: 2 },
// //   { number: 62, name: "الجمعة", pages: 2 },
// //   { number: 63, name: "المنافقون", pages: 2 },
// //   { number: 64, name: "التغابن", pages: 2 },
// //   { number: 65, name: "الطلاق", pages: 3 },
// //   { number: 66, name: "التحريم", pages: 2 },
// //   { number: 67, name: "الملك", pages: 3 },
// //   { number: 68, name: "القلم", pages: 3 },
// //   { number: 69, name: "الحاقة", pages: 4 },
// //   { number: 70, name: "المعارج", pages: 2 },
// //   { number: 71, name: "نوح", pages: 2 },
// //   { number: 72, name: "الجن", pages: 3 },
// //   { number: 73, name: "المزمل", pages: 2 },
// //   { number: 74, name: "المدثر", pages: 3 },
// //   { number: 75, name: "القيامة", pages: 2 },
// //   { number: 76, name: "الإنسان", pages: 3 },
// //   { number: 77, name: "المرسلات", pages: 2 },
// //   { number: 78, name: "النبأ", pages: 2 },
// //   { number: 79, name: "النازعات", pages: 2 },
// //   { number: 80, name: "عبس", pages: 2 },
// //   { number: 81, name: "التكوير", pages: 1 },
// //   { number: 82, name: "الإنفطار", pages: 1 },
// //   { number: 83, name: "المطففين", pages: 2 },
// //   { number: 84, name: "الإنشقاق", pages: 2 },
// //   { number: 85, name: "البروج", pages: 1 },
// //   { number: 86, name: "الطارق", pages: 1 },
// //   { number: 87, name: "الأعلى", pages: 1 },
// //   { number: 88, name: "الغاشية", pages: 2 },
// //   { number: 89, name: "الفجر", pages: 2 },
// //   { number: 90, name: "البلد", pages: 1 },
// //   { number: 91, name: "الشمس", pages: 1 },
// //   { number: 92, name: "الليل", pages: 2 },
// //   { number: 93, name: "الضحى", pages: 1 },
// //   { number: 94, name: "الشرح", pages: 1 },
// //   { number: 95, name: "التين", pages: 1 },
// //   { number: 96, name: "العلق", pages: 1 },
// //   { number: 97, name: "القدر", pages: 1 },
// //   { number: 98, name: "البينة", pages: 2 },
// //   { number: 99, name: "الزلزلة", pages: 1 },
// //   { number: 100, name: "العاديات", pages: 1 },
// //   { number: 101, name: "القارعة", pages: 1 },
// //   { number: 102, name: "التكاثر", pages: 1 },
// //   { number: 103, name: "العصر", pages: 1 },
// //   { number: 104, name: "الهمزة", pages: 1 },
// //   { number: 105, name: "الفيل", pages: 1 },
// //   { number: 106, name: "قريش", pages: 1 },
// //   { number: 107, name: "الماعون", pages: 1 },
// //   { number: 108, name: "الكوثر", pages: 1 },
// //   { number: 109, name: "الكافرون", pages: 1 },
// //   { number: 110, name: "النصر", pages: 1 },
// //   { number: 111, name: "المسد", pages: 1 },
// //   { number: 112, name: "الإخلاص", pages: 1 },
// //   { number: 113, name: "الفلق", pages: 1 },
// //   { number: 114, name: "الناس", pages: 1 },
// // ];
// const surasData = [
//   { number: 1,   name: "الفاتحة",   name_en: "Al-Fatihah",    pages: 1 },
//   { number: 2,   name: "البقرة",    name_en: "Al-Baqarah",    pages: 48 },
//   { number: 3,   name: "آل عمران",  name_en: "Al-Imran",      pages: 29 },
//   { number: 4,   name: "النساء",    name_en: "Al-Nisa",       pages: 24 },
//   { number: 5,   name: "المائدة",   name_en: "Al-Maidah",     pages: 23 },
//   { number: 6,   name: "الأنعام",   name_en: "Al-Anam",       pages: 26 },
//   { number: 7,   name: "الأعراف",   name_en: "Al-Araf",       pages: 24 },
//   { number: 8,   name: "الأنفال",   name_en: "Al-Anfal",      pages: 10 },
//   { number: 9,   name: "التوبة",    name_en: "Al-Tawbah",     pages: 20 },
//   { number: 10,  name: "يونس",      name_en: "Yunus",         pages: 11 },
//   { number: 11,  name: "هود",       name_en: "Hud",           pages: 12 },
//   { number: 12,  name: "يوسف",      name_en: "Yusuf",         pages: 12 },
//   { number: 13,  name: "الرعد",     name_en: "Al-Rad",        pages: 6 },
//   { number: 14,  name: "ابراهيم",    name_en: "Ibrahim",       pages: 7 },
//   { number: 15,  name: "الحجر",     name_en: "Al-Hijr",       pages: 6 },
//   { number: 16,  name: "النحل",     name_en: "Al-Nahl",       pages: 13 },
//   { number: 17,  name: "الإسراء",   name_en: "Al-Isra",       pages: 12 },
//   { number: 18,  name: "الكهف",     name_en: "Al-Kahf",       pages: 12 },
//   { number: 19,  name: "مريم",      name_en: "Maryam",        pages: 10 },
//   { number: 20,  name: "طه",        name_en: "TaHa",          pages: 12 },
//   { number: 21,  name: "الأنبياء",   name_en: "Al-Anbiya",     pages: 11 },
//   { number: 22,  name: "الحج",      name_en: "Al-Hajj",       pages: 10 },
//   { number: 23,  name: "المؤمنون",   name_en: "Al-Muminun",    pages: 10 },
//   { number: 24,  name: "النور",     name_en: "Al-Nur",        pages: 12 },
//   { number: 25,  name: "الفرقان",   name_en: "Al-Furqan",     pages: 6 },
//   { number: 26,  name: "الشعراء",    name_en: "Al-Shuara",     pages: 9 },
//   { number: 27,  name: "النمل",     name_en: "An-Naml",       pages: 10 },
//   { number: 28,  name: "القصص",     name_en: "Al-Qasas",      pages: 11 },
//   { number: 29,  name: "العنكبوت",   name_en: "Al-Ankabut",    pages: 7 },
//   { number: 30,  name: "الروم",     name_en: "Al-Rum",        pages: 6 },
//   { number: 31,  name: "لقمان",      name_en: "Luqman",        pages: 4 },
//   { number: 32,  name: "السجدة",    name_en: "Al-Sajdah",     pages: 3 },
//   { number: 33,  name: "الأحزاب",   name_en: "Al-Ahzab",      pages: 12 },
//   { number: 34,  name: "سبأ",       name_en: "Saba",          pages: 9 },
//   { number: 35,  name: "فاطر",      name_en: "Fatir",         pages: 9 },
//   { number: 36,  name: "يس",        name_en: "Yasin",         pages: 8 },
//   { number: 37,  name: "الصافات",    name_en: "Al-Saffat",     pages: 10 },
//   { number: 38,  name: "ص",         name_en: "Sad",           pages: 6 },
//   { number: 39,  name: "الزمر",     name_en: "Al-Zumar",      pages: 11 },
//   { number: 40,  name: "غافر",      name_en: "Ghafir",        pages: 11 },
//   { number: 41,  name: "فصلت",      name_en: "Fussilat",      pages: 6 },
//   { number: 42,  name: "الشورى",     name_en: "Al-Shura",      pages: 8 },
//   { number: 43,  name: "الزخرف",     name_en: "Al-Zukhruf",    pages: 7 },
//   { number: 44,  name: "الدخان",     name_en: "Al-Dukhan",     pages: 3 },
//   { number: 45,  name: "الجاثية",    name_en: "Al-Jathiyah",   pages: 4 },
//   { number: 46,  name: "الأحقاف",    name_en: "Al-Ahqaf",      pages: 5 },
//   { number: 47,  name: "محمد",      name_en: "Muhammad",      pages: 6 },
//   { number: 48,  name: "الفتح",     name_en: "Al-Fath",       pages: 5 },
//   { number: 49,  name: "الحجرات",    name_en: "Al-Hujurat",    pages: 3 },
//   { number: 50,  name: "ق",         name_en: "Qaf",           pages: 3 },
//   { number: 51,  name: "الذاريات",   name_en: "Al-Dhariyat",   pages: 3 },
//   { number: 52,  name: "الطور",     name_en: "Al-Tur",        pages: 4 },
//   { number: 53,  name: "النجم",     name_en: "Al-Najm",       pages: 3 },
//   { number: 54,  name: "القمر",     name_en: "Al-Qamar",      pages: 3 },
//   { number: 55,  name: "الرحمن",     name_en: "Al-Rahman",     pages: 3 },
//   { number: 56,  name: "الواقعة",    name_en: "Al-Waqiah",     pages: 4 },
//   { number: 57,  name: "الحديد",     name_en: "Al-Hadid",      pages: 5 },
//   { number: 58,  name: "المجادلة",    name_en: "Al-Mujadila",   pages: 3 },
//   { number: 59,  name: "الحشر",      name_en: "Al-Hashr",      pages: 4 },
//   { number: 60,  name: "الممتحنة",    name_en: "Al-Mumtahanah", pages: 3 },
//   { number: 61,  name: "الصف",       name_en: "Al-Saff",       pages: 2 },
//   { number: 62,  name: "الجمعة",     name_en: "Al-Jumuah",     pages: 2 },
//   { number: 63,  name: "المنافقون",   name_en: "Al-Munafiqun",  pages: 2 },
//   { number: 64,  name: "التغابن",     name_en: "Al-Taghabun",   pages: 2 },
//   { number: 65,  name: "الطلاق",     name_en: "Al-Talaq",      pages: 3 },
//   { number: 66,  name: "التحريم",     name_en: "Al-Tahrim",     pages: 2 },
//   { number: 67,  name: "الملك",      name_en: "Al-Mulk",       pages: 3 },
//   { number: 68,  name: "القلم",      name_en: "Al-Qalam",      pages: 3 },
//   { number: 69,  name: "الحاقة",     name_en: "Al-Haqqah",     pages: 4 },
//   { number: 70,  name: "المعارج",     name_en: "Al-Maarij",     pages: 2 },
//   { number: 71,  name: "نوح",        name_en: "Nuh",           pages: 2 },
//   { number: 72,  name: "الجن",       name_en: "Al-Jinn",       pages: 3 },
//   { number: 73,  name: "المزمل",      name_en: "Al-Muzzammil",  pages: 2 },
//   { number: 74,  name: "المدثر",      name_en: "Al-Muddaththir",pages: 3 },
//   { number: 75,  name: "القيامة",     name_en: "Al-Qiyamah",    pages: 2 },
//   { number: 76,  name: "الإنسان",      name_en: "Al-Insan",      pages: 3 },
//   { number: 77,  name: "المرسلات",     name_en: "Al-Mursalat",   pages: 2 },
//   { number: 78,  name: "النبأ",       name_en: "Al-Naba",       pages: 2 },
//   { number: 79,  name: "النازعات",     name_en: "Al-Naziat",     pages: 2 },
//   { number: 80,  name: "عبس",        name_en: "Abasa",         pages: 2 },
//   { number: 81,  name: "التكوير",     name_en: "Al-Takwir",     pages: 1 },
//   { number: 82,  name: "الإنفطار",     name_en: "Al-Infitar",    pages: 1 },
//   { number: 83,  name: "المطففين",     name_en: "Al-Mutaffifin", pages: 2 },
//   { number: 84,  name: "الإنشقاق",     name_en: "Al-Inshiqaq",   pages: 2 },
//   { number: 85,  name: "البروج",      name_en: "Al-Buruj",      pages: 1 },
//   { number: 86,  name: "الطارق",      name_en: "At-Tariq",      pages: 1 },
//   { number: 87,  name: "الأعلى",      name_en: "Al-Ala",        pages: 1 },
//   { number: 88,  name: "الغاشية",     name_en: "Al-Ghashiyah",  pages: 2 },
//   { number: 89,  name: "الفجر",       name_en: "Al-Fajr",       pages: 2 },
//   { number: 90,  name: "البلد",       name_en: "Al-Balad",      pages: 1 },
//   { number: 91,  name: "الشمس",       name_en: "Al-Shams",      pages: 1 },
//   { number: 92,  name: "الليل",       name_en: "Al-Layl",       pages: 2 },
//   { number: 93,  name: "الضحى",       name_en: "Al-Duhaa",      pages: 1 },
//   { number: 94,  name: "الشرح",       name_en: "Al-Sharh",      pages: 1 },
//   { number: 95,  name: "التين",       name_en: "Al-Tin",        pages: 1 },
//   { number: 96,  name: "العلق",       name_en: "Al-Alaq",       pages: 1 },
//   { number: 97,  name: "القدر",       name_en: "Al-Qadr",       pages: 1 },
//   { number: 98,  name: "البينة",      name_en: "Al-Bayyinah",   pages: 2 },
//   { number: 99,  name: "الزلزلة",     name_en: "Al-Zalzalah",   pages: 1 },
//   { number: 100, name: "العاديات",     name_en: "Al-Adiyat",     pages: 1 },
//   { number: 101, name: "القارعة",     name_en: "Al-Qariah",     pages: 1 },
//   { number: 102, name: "التكاثر",     name_en: "Al-Takathur",   pages: 1 },
//   { number: 103, name: "العصر",       name_en: "Al-Asr",        pages: 1 },
//   { number: 104, name: "الهمزة",      name_en: "Al-Humazah",    pages: 1 },
//   { number: 105, name: "الفيل",       name_en: "Al-Fil",        pages: 1 },
//   { number: 106, name: "قريش",        name_en: "Quraysh",       pages: 1 },
//   { number: 107, name: "الماعون",      name_en: "Al-Maun",       pages: 1 },
//   { number: 108, name: "الكوثر",      name_en: "Al-Kawthar",    pages: 1 },
//   { number: 109, name: "الكافرون",     name_en: "Al-Kafirun",    pages: 1 },
//   { number: 110, name: "النصر",       name_en: "Al-Nasr",       pages: 1 },
//   { number: 111, name: "المسد",       name_en: "Al-Masad",      pages: 1 },
//   { number: 112, name: "الإخلاص",     name_en: "Al-Ikhlas",     pages: 1 },
//   { number: 113, name: "الفلق",       name_en: "Al-Falaq",      pages: 1 },
//   { number: 114, name: "الناس",       name_en: "Al-Nas",        pages: 1 },
// ];


// نحسب المجموع الكلي لصفحات القرآن من المصفوفة
const totalQuranPages = surasData.reduce((acc, sura) => acc + sura.pages, 0);

function MemoryPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.app.loading);

  // State for daily pages
  const [dailyPages, setDailyPages] = useState(1);

  // State for memorized suras (array of sura "number")
  const [memorizedSuras, setMemorizedSuras] = useState([]);

  // Calculate total pages in the entire Quran
  const totalQuranPages = surasData.reduce((acc, sura) => acc + sura.pages, 0);

  const handleMemorizedSuraChange = (suraNumber) => {
    setMemorizedSuras((prev) => {
      if (prev.includes(suraNumber)) {
        // If sura was already selected, remove it
        return prev.filter((num) => num !== suraNumber);
      } else {
        // Otherwise, add it
        return [...prev, suraNumber];
      }
    });
  };

  // Summation of pages for memorized suras
  const memorizedPages = surasData
    .filter((sura) => memorizedSuras.includes(sura.number))
    .reduce((acc, sura) => acc + sura.pages, 0);

  const remainingPages = totalQuranPages - memorizedPages;
  const totalDays = remainingPages / dailyPages;
  const years = Math.floor(totalDays / 365);
  const daysAfterYears = Math.floor(totalDays % 365);
  const months = Math.floor(daysAfterYears / 30);
  const days = Math.floor(daysAfterYears % 30);

  // The crucial part: converting front-end data to the shape your Django view wants
  const saveSettingsBtn = async () => {
    console.log("Saving settings...");
    const dataToSend = {
      daily_target: dailyPages,
      surahs: memorizedSuras.map((num) => ({
        number: num,
      })),
    };
  
    const result = await dispatch(postSettings(dataToSend));
    console.log("Result from thunk:", result);

    // If your thunk returns something like { success: true } on success:
    if (result) {
      console.log("Settings saved successfully:", dataToSend);
      navigate("/home");
    }
  };
  

  const saveDataBtn = () => {
    navigate("/home");
  };

  return (
    <div className="memory-container">
      <h1 className="title">ترسيخ</h1>

      <h2 className="sub-title">مقدار الحفظ اليومي:</h2>
      <div className="daily-memorize-section">
        <div className="daily-options">
          <label>
            <input
              type="radio"
              name="dailyPages"
              value="1"
              checked={dailyPages === 1}
              onChange={() => setDailyPages(1)}
            />
            <span>نصف صفحة</span>
          </label>
          <label>
            <input
              type="radio"
              name="dailyPages"
              value="2"
              checked={dailyPages === 2}
              onChange={() => setDailyPages(2)}
            />
            <span>صفحة</span>
          </label>
          <label>
            <input
              type="radio"
              name="dailyPages"
              value="1.5"
              checked={dailyPages === 3}
              onChange={() => setDailyPages(3)}
            />
            <span>صفحة ونصف</span>
          </label>
          <label>
            <input
              type="radio"
              name="dailyPages"
              value="2"
              checked={dailyPages === 4}
              onChange={() => setDailyPages(4)}
            />
            <span>صفحتان</span>
          </label>
        </div>
      </div>

      <h2 className="sub-title">السور التي حفظتها:</h2>
      <div className="suras-section">
        <div className="suras-list">
          {surasData.map((sura) => (
            <label key={sura.number} className="sura-label">
              <input
                type="checkbox"
                checked={memorizedSuras.includes(sura.number)}
                onChange={() => handleMemorizedSuraChange(sura.number)}
              />
              {sura.name} ({sura.pages} صفحة)
            </label>
          ))}
        </div>
      </div>

      <div className="result-section">
        <h2 className="result-title">
          المدة المقدرة لإتمام حفظ القرآن:{" "}
          <span className="result">
            {years} سنة و {months} شهر و {days} يوم
          </span>
        </h2>
        <p className="sub-info">
          عدد الصفحات المحفوظة حاليًا:
          <span className="sub-info-text">{memorizedPages} صفحة.</span>
        </p>
        <p className="sub-info">
          الصفحات المتبقية:
          <span className="sub-info-text">{remainingPages} صفحة.</span>
        </p>
      </div>

      <div>
        <button className="save-button" onClick={saveSettingsBtn}>
          حفظ
        </button>
      </div>
    </div>
  );
}

export default MemoryPage;